import { BRAND_KEYWORDS, NAME, RIGHT_TYPE, RIGHT_TYPE_POSTS, SOCIAL_MEDIA_POST, STATUS } from '../../../fields'
import { RIGHT_STATUS } from '../../../../../../../constants/rights'
import { FACEBOOK_PROVIDER_PLATFORM } from '../../../../../../../constants/selectLists/platformList'

export const transformValuesToBE = values => {
  const filledKeywords = values[BRAND_KEYWORDS].map(item => item.text).filter(item => !!item)

  return {
    [NAME]: values[NAME],
    ...(filledKeywords.length && { [BRAND_KEYWORDS]: filledKeywords }),
    ...(values[SOCIAL_MEDIA_POST] && {
      pages: [
        {
          // For now provider is always hardcoded to 'facebook'
          provider: FACEBOOK_PROVIDER_PLATFORM,
          page_id: values[SOCIAL_MEDIA_POST]
        }
      ]
    }),
    // hardcoded values
    [STATUS]: RIGHT_STATUS.LIVE,
    [RIGHT_TYPE]: RIGHT_TYPE_POSTS,
    allocation: 99,
    allocation_unit: 7 // 7 === posts
  }
}
